module.exports = __webpack_public_path__ + "img/consultoria_16-9_1920.95ccdc2e.jpg";